import React from 'react'
import ContentLoader from 'react-content-loader'

const ClientInfoLoader = () => {
  return (
    <ContentLoader
      speed={2}
      width={1464}
      height={1200}
      viewBox='0 0 1464 1200'
      backgroundColor='#f3f3f3'
      foregroundColor='#ecebeb'
    >
      <>
        <rect x="20" y="14" rx="3" ry="3" width="173" height="25" />
        <rect x="205" y="14" rx="3" ry="3" width="173" height="25" />
        <rect x="20" y="76" rx="3" ry="3" width="173" height="25" />
        <rect x="238" y="74" rx="3" ry="3" width="25" height="25" />
        <rect x="277" y="74" rx="3" ry="3" width="154" height="25" />
        <rect x="20" y="114" rx="3" ry="3" width="417" height="215" />
        <rect x="464" y="74" rx="3" ry="3" width="173" height="25" />
        <rect x="680" y="74" rx="3" ry="3" width="25" height="25" />
        <rect x="720" y="74" rx="3" ry="3" width="154" height="25" />

        <rect x="464" y="114" rx="3" ry="3" width="417" height="215" />
        <rect x="20" y="375" rx="3" ry="3" width="173" height="25" />
        <rect x="243" y="377" rx="3" ry="3" width="25" height="25" />
        <rect x="280" y="374" rx="3" ry="3" width="154" height="25" />
        <rect x="20" y="418" rx="3" ry="3" width="417" height="215" />

        <rect x="28" y="685" rx="3" ry="3" width="173" height="25" />
        <rect x="251" y="687" rx="3" ry="3" width="25" height="25" />
        <rect x="292" y="685" rx="3" ry="3" width="154" height="25" />
        <rect x="31" y="724" rx="3" ry="3" width="417" height="215" />
      </>
    </ContentLoader>
  )
}

export default ClientInfoLoader